import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayButton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_3820_46)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M27.3227 10.6253L14.6053 1.3C13.612 0.572646 12.4367 0.13455 11.2097 0.0342704C9.98265 -0.0660089 8.75181 0.175446 7.65359 0.731872C6.55537 1.2883 5.63269 2.13796 4.9878 3.18668C4.34291 4.23539 4.00101 5.4422 4.00001 6.67333V25.3333C3.99809 26.5657 4.3382 27.7744 4.98247 28.8249C5.62675 29.8754 6.54991 30.7265 7.6492 31.2835C8.74849 31.8404 9.98078 32.0814 11.2089 31.9796C12.437 31.8777 13.6128 31.4371 14.6053 30.7067L27.3227 21.3813C28.1665 20.7621 28.8527 19.9528 29.3256 19.0191C29.7986 18.0853 30.0451 17.0534 30.0451 16.0067C30.0451 14.96 29.7986 13.928 29.3256 12.9943C28.8527 12.0605 28.1665 11.2513 27.3227 10.632V10.6253Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3820_46",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgPlayButton;
